export const currentIndex = state => state.currentIndex

export const showTask = state => state.showTask

export const showWaterArea = state => state.showWaterArea

export const showEcologicalLine = state => state.showEcologicalLine

export const showNatureReserve = state => state.showNatureReserve

export const showPumpStation = state => state.showPumpStation

export const showOutLet = state => state.showOutLet

export const showEnterprise = state => state.showEnterprise

export const showUav = state => state.showUav

export const showVehicle = state => state.showVehicle

export const showEquipment = state => state.showEquipment

export const showPersonnel = state => state.showPersonnel

export const showLeftMenu = state => state.showLeftMenu

export const showRightMenu = state => state.showRightMenu

export const showNavBar = state => state.showNavBar

export const beginRang = state => state.beginRang

export const changeMap = state => state.changeMap

export const showStatistical = state => state.showStatistical

export const changeType = state => state.changeType

export const changePoint = state => state.changePoint

export const filteredSessions = state => {
  return state.sessions.filter(
    session => session.name.toLocaleLowerCase().indexOf(state.filterKey) !== -1);
};
export const currentSession = state => {
  return state.sessions.find(session => session.toUid === state.currentSessionId);
};
export const emailSends = state => {
  return state.addMail;
};
export const videoNotice = state => {
  return state.noticeInfo.url;
};
//改变logo
export const getLogo = state => {
  return state.logo==null?'':state.logo;
};

export const unreadMsg = state => {
  return state.unreadCount;
};
export const newheat = state => {
  return state.heartss;
};
export const chatop = state => {
  return state.chatopid;
};
export const lbcolor = state => {
  return state.lbcolors;
};

export const setDetail = state => {
  return state.isShowRights;
};
//任务详情信息
export const setTaskInfo = state => {
  return state.taskDetails;
};



// WEBPACK FOOTER //
// ./src/store/getters.js